(function() {
  document.getElementById('selectPayment').addEventListener('change', function(event) {
    const selectedText = event.target.options[event.target.selectedIndex];
    const variantId = selectedText.getAttribute('data-variant-id');
    const variantName = this.value.trim().toLowerCase();

    if (variantName.includes('credito') || variantName.includes('cuotas') || variantName.includes('diferido')) {
      document.getElementById('price__cuotas').style.display = 'inline-block';
      document.getElementById('price__contado').style.display = 'none';
    } else {
      document.getElementById('price__cuotas').style.display = 'none';
      document.getElementById('price__contado').style.display = 'inline-block';
    }

    document.querySelectorAll('.price_modal').forEach(priceElement => {
      priceElement.style.display = 'none';
      if (priceElement.id.includes(variantId)) {
        priceElement.style.display = 'block';
      }
    });

    document.getElementById('input_hidden_price_selector').value = variantId;
  });
})();

  function selectVariant(element, variantId, variantTitle) {
    const variantName = variantTitle.trim().toLowerCase();
    
    // Remove selected class from all pills
    document.querySelectorAll('.product-form__link--pill').forEach(pill => {
      pill.classList.remove('product-form__link--pill-selected');
      pill.classList.add('product-form__link--pill-no-selected');
    });

    document.querySelectorAll('.price_modal').forEach(priceElement => {
      priceElement.style.display = 'none';
    });

    document.getElementById(`price_show_${variantName}`).style.display = 'block';

    if (variantName.includes('credito') || variantName.includes('cuotas') || variantName.includes('diferido')) {
      document.getElementById('price__cuotas').style.display = 'inline-block';
      document.getElementById('price__contado').style.display = 'none';
    } else {
      document.getElementById('price__cuotas').style.display = 'none';
      document.getElementById('price__contado').style.display = 'inline-block';
    }
    
    // Add selected class to clicked pill

    element.classList.remove('product-form__link--pill-no-selected');
    element.classList.add('product-form__link--pill-selected');
    
    // Update the hidden select element
    document.getElementById('ProductSelect').value = variantId;
    
    // Trigger change event (important for Shopify's JS to detect the variant change)
    const event = new Event('change', { bubbles: true });
    document.getElementById('ProductSelect').dispatchEvent(event);
}
  
  // Initialize first variant as selected on page load
document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('.product-form__link--pill')) {
        document.querySelector('.product-form__link--pill').classList.add('selected');
    }
});